import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axiosInstance";
import { Button, Card, Spinner, Table, Row, Col } from "react-bootstrap";
import './css/DetalleEvento.css';

function DetalleEvento() {
  const { id } = useParams();
  const [evento, setEvento] = useState(null);
  const [inscripciones, setInscripciones] = useState([]);
  const navegar = useNavigate();
  const navigate = useNavigate();

  const CrearInscripcion = () => {
    navegar("/CrearInscripcion");
  };

  const volver = () => {
    navigate(-1);
  };

  useEffect(() => {
    const obtenerEvento = async () => {
      try {
        const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/eventos/${id}`);
        const eventoRecibido = respuesta.data.evento;

        setEvento({
          nombre: eventoRecibido.nombre,
          tipo_evento: eventoRecibido.tipo_evento,
          estado_tipo: eventoRecibido.estado_tipo,
          fecha_inicio: eventoRecibido.fecha_inicio,
          fecha_fin: eventoRecibido.fecha_fin,
          creador: eventoRecibido.creador,
        });
      } catch (error) {
        console.error("Error al cargar evento:", error);
      }
    };

    const obtenerInscripciones = async () => {
      try {
        const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/inscripciones`);
        const todas = respuesta.data;

        const filtradas = todas.filter(i => i.evento_id == id);
        setInscripciones(filtradas);
      } catch (error) {
        console.error("Error al cargar inscripciones:", error);
      }
    };

    obtenerEvento();
    obtenerInscripciones();
  }, [id]);

  return (
    <div className="contenedorEventos p-4">
      {evento ? (
        <Row className="mb-4">
          <div className="justify-content-between align-items-center mb-4">
            <Button className="boton_accion" size="sm" onClick={volver}>⬅ Volver</Button>
            <h1 className="tituloEventos m-3">{evento.nombre}</h1>
            <Col className="tipo">
              {evento.tipo_evento?.nombre}<br />
            </Col>
          </div>
          <Col>
            <Card className="contenido">
              <Card.Body className="evento">
                <Card.Text>
                  <Col className="estado">
                    <strong>Periodo de Inscripción:</strong>
                    {evento.estado_tipo?.nombre}
                  </Col>
                  <Row>
                    <Col md={6} className="fecha">
                      <strong>Fecha de inicio:</strong><br />
                      {evento.fecha_inicio}
                    </Col>
                    <Col md={6} className="fecha">
                      <strong>Fecha de fin:</strong><br />
                      {evento.fecha_fin}
                    </Col>
                    <Col md={12} className="creador">
                      <strong>Creador:</strong><br />
                      {evento.creador?.name}
                    </Col>
                  </Row>
                </Card.Text>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Button className="boton_nuevo" onClick={CrearInscripcion}>
                    Empezar Mi Inscripción
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <p className="spinner text-center">
          <Spinner animation="grow" />
        </p>
      )}

      
      <div className="justify-content-between align-items-center mb-4 mt-5">
        <h2 className="tituloEventos m-3">INSCRIPCIONES ASOCIADAS A ESTE EVENTO</h2>
      </div>

      {inscripciones.length > 0 ? (
        <Table striped bordered hover responsive className="tabla-inscripciones">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>DNI</th>
              <th>Tutor</th>
              <th>Usuario</th>
            </tr>
          </thead>
          <tbody>
            {inscripciones.map(inscripcion => (
              <tr key={inscripcion.inscripcion_id}>
                <td>{inscripcion.nombre} {inscripcion.apellidos}</td>
                <td>{inscripcion.dni}</td>
                <td>{inscripcion.nombre_tutor} {inscripcion.apellidos_tutor}</td>
                <td>{inscripcion.user?.name}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className=" text-center">
          no hay ninguna inscripción asociada a este evento.
        </p>
      )}
    </div>
  );
}

export default DetalleEvento;
